import { Device, type DeviceInfo } from '@capacitor/device';

export const loginHelpers = {
  async createLoginRequestBody(username: string, password: string, siteName: string) {
    const platformStore = usePlatformStore();
    const config = useRuntimeConfig();
    const softwareVersion = await platformStore.getSoftwareVersion();
    const platformVersion = await platformStore.getPlatformVersion();
    const deviceInfo: DeviceInfo = await Device.getInfo();

    function getSource() {
      if (config.public.requestSource === 'browser' ) {
        return 'AppBrowser';
      }

      return 'App';
    }

    const loginRequest: AuthenticateRequest = {
      Username: username,
      Password: password,
      SiteName: siteName,
      SoftwareVersion: softwareVersion,
      Source: getSource(),
      PlatformName: deviceInfo.platform,
      PlatformVersion: platformVersion,
      Manufacturer: deviceInfo.manufacturer,
      ModelName: deviceInfo.model
    };

    loginRequest.Username = loginRequest.Username.trim();
    loginRequest.SiteName = loginRequest.SiteName.trim();
    loginRequest.SiteName = loginRequest.SiteName.includes('ekomplet_') === false ? 'ekomplet_' + loginRequest.SiteName : loginRequest.SiteName;

    return loginRequest;
  },

  async fetchConfigurationData(): Promise<void> {
    const userConfiguration = useUserConfigurationStore();
    
    await userConfiguration.setUserConfiguration();
    
    if (!userConfiguration._userConfiguration || userConfiguration.userConfiguration?.IsWebUser) {
      return;
    }

    const siteConfiguration = useSiteConfigurationStore();
    const fitterHourStore = useFitterHourStore();
    const filterWorksheets = useFilterWorksheetsStore();
    const accountSettings = useAccountSettingsStore();
    const settingsStore = useSettingsStore();
    const fileUploadStore = useFileUploadStore();
    
    const { utilizeBankHolidayCalendar } = useFeatureToggles();

    const setFitterHourConfigurationPromise = fitterHourStore.setFitterHourConfiguration();
    const setSiteConfigurationPromise = siteConfiguration.setSiteConfiguration();
    const fetchFittersPromise = userConfiguration.fetchFitters();
    const bankHolidaysPromise = utilizeBankHolidayCalendar ? siteConfiguration.setBankHolidays() : Promise.resolve();
    const setUnitsPromise = siteConfiguration.setUnits();
    
    await settingsStore.loadUserSettings();
    
    await fetchFittersPromise;
    
    await Promise.all([
      setFitterHourConfigurationPromise,
      setSiteConfigurationPromise,
      accountSettings.getAccountSettings(),
      fitterHourStore.setFitterCategoriesDefault(userConfiguration.fitterId),
      filterWorksheets.fetchWorksheetsAssociatedToFitters([userConfiguration.fitterId]),
      bankHolidaysPromise,
      setUnitsPromise,
      fileUploadStore.initialize()
    ]);
  }
};
